import { render } from "./TheHeaderNavbar.vue?vue&type=template&id=36abbc11"
import script from "./TheHeaderNavbar.vue?vue&type=script&lang=js"
export * from "./TheHeaderNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script